export * from './src/change-email-view.component';
